import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from 'semantic-ui-react';
import { humanSizes } from '../../config/utils';
import * as classes from './classes.module.scss';

const Sizes = ({
  landscape,
  displayPaperWidth,
  displayPaperHeight,
  displayPrintWidth,
  displayPrintHeight,
  displayPrintWidthNoMat,
  displayPrintHeightNoMat,
  frameMat,
  frame,
  frameDisplayDepth,
  frameDisplayWidth,
  isWorkSizeHidden,
  paperMaterial,
  frameFinalFramedSize,
  nonGlare
}) => {
  const hs = frameMat === 0
    ? humanSizes(landscape, displayPrintWidthNoMat, displayPrintHeightNoMat)
    : humanSizes(landscape, displayPrintWidth, displayPrintHeight);

  const frameDetails = frame ? (
    <div>
      { frame }
      &nbsp;frame
      <br />
      Frame Depth:&nbsp;
      <strong>{ frameDisplayDepth }</strong>
      <br />
      Frame Width:&nbsp;
      <strong>{ frameDisplayWidth }</strong>
      { window.currentLocale.unit }
      <br />
      Final Framed Size:&nbsp;
      <strong>{ frameFinalFramedSize }</strong>
    </div>
  ) : null;

  const phs = humanSizes(landscape, displayPaperWidth, displayPaperHeight);

  const hidden = isWorkSizeHidden ? (
    <Icon name="eye slash" />
  ) : null;

  return (
    <div className={ classes.sizes }>
      <div>
        Image Size:&nbsp;
        { hidden }
        <strong>{ hs }</strong>
      </div>
      <div>
        { paperMaterial === 'Canvas' ? 'Canvas' : 'Paper' }
        &nbsp;Size
        { frame ? ' (unframed)' : null }
        :&nbsp;
        <strong>{ phs }</strong>
      </div>
      <div>
        Printed on&nbsp;
        { paperMaterial }
      </div>
      <div>
        { frameDetails }
      </div>
      {
        nonGlare ? (
          <div>
            Non-glare UV Plexiglass
          </div>
        ) : null
      }
    </div>
  );
};

Sizes.propTypes = {
  landscape: PropTypes.bool,
  displayPaperWidth: PropTypes.number,
  displayPaperHeight: PropTypes.number,
  displayPrintWidth: PropTypes.number,
  displayPrintHeight: PropTypes.number,
  displayPrintWidthNoMat: PropTypes.number,
  displayPrintHeightNoMat: PropTypes.number,
  frameMat: PropTypes.number,
  frame: PropTypes.string,
  frameDisplayDepth: PropTypes.string,
  frameDisplayWidth: PropTypes.number,
  paperMaterial: PropTypes.string,
  isWorkSizeHidden: PropTypes.bool,
  frameFinalFramedSize: PropTypes.string,
  nonGlare: PropTypes.bool
};

export default Sizes;
